import React, { useState } from 'react';
import { Field, Form } from 'react-final-form';
import Box from '@mui/material/Box';
import { InputAdornment } from '@mui/material';
import TextFieldAdapter from '../../FinalFormAdapters/TextFieldAdapter';
import { emailValidator } from './PersonFormUtils';
import MfButton from '../../UI/Button/MfButton';
import { changeEmail } from '../../../api/user';
import useClosableSnackbar from '../../../hooks/useClosableSnackbar';
import { errorToString } from '../../../helpers/Helper';
import useAccount from '../../../hooks/useAccount';

const EmailForm = () => {
  const { accountResponse, updateAccountResponse } = useAccount();
  const { showSnackbar } = useClosableSnackbar();
  const [processing, setProcessing] = useState(false);

  if (!accountResponse) {
    return null;
  }

  const submit = async ({ email }: { email: string }) => {
    setProcessing(true);
    try {
      await changeEmail(email);
      updateAccountResponse({ ...accountResponse, email });
    } catch (e) {
      showSnackbar(errorToString(e));
      console.log(e);
    }
    setProcessing(false);
  };

  return (
    <Form
      initialValues={{ email: accountResponse?.email }}
      onSubmit={submit}
      render={({ handleSubmit, touched, valid, submitting, pristine }) => (
        <form onSubmit={handleSubmit}>
          <Box sx={{ mb: 2 }}>
            <Field
              label="E-mail"
              name="email"
              component={TextFieldAdapter}
              validate={emailValidator}
              InputProps={{ sx: { pr: 1 } }}
              endAdornment={
                <InputAdornment position="end">
                  <MfButton
                    type="submit"
                    disabled={submitting || pristine || processing}
                    variant="contained"
                  >
                    Сохранить e-mail
                  </MfButton>
                </InputAdornment>
              }
            />
          </Box>
        </form>
      )}
    />
  );
};

export default EmailForm;
